import { DETECTION_TYPES_CONFIG } from 'constants/av-review';

const getDetectionSummary = (events = []) =>
  Object.entries(
    events.reduce((counts, { event_type }) => {
      if (event_type) counts[event_type] = (counts[event_type] || 0) + 1;
      return counts;
    }, {}),
  ).map(([type, count]) => ({
    type,
    count,
    label: DETECTION_TYPES_CONFIG[type]?.label || type,
  }));

export const mapReviewsForDisplay = (reviews = []) =>
  reviews.map(
    ({ id, reviewer_id, teacher_classroom_id, status, events, teacher_classroom }) => {
      const { teacher_id, class_type, session_date } = teacher_classroom || {};
      return {
        id,
        reviewerId: reviewer_id || '-',
        classroomId: teacher_classroom_id || '-',
        teacherId: teacher_id || '-',
        classType: class_type || '-',
        sessionDate: session_date || '-',
        detections: getDetectionSummary(events),
        status,
      };
    },
  );
